import { render, staticRenderFns } from "./programsCard.vue?vue&type=template&id=42e04ea2&"
import script from "./programsCard.vue?vue&type=script&lang=js&"
export * from "./programsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports